import { TournamentStatus } from '@repo/database/src/types';
import { Prisma } from '@repo/database/src/types';
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';

import { TournamentWComputed } from '../../tournament-types';

export enum TournamentSortBy {
  GUARANTEED_PRIZE_POOL = 'guaranteedPrizePool',
  BUY_IN = 'buyIn',
  GAME = 'game',
  START_TIME = 'startTime',
  TABLE_SIZE = 'tableSize',
  STATUS = 'status',
  NAME = 'name',
}

export class DateRangeFilterDto {
  @IsOptional()
  @Type(() => String)
  from?: string;

  @IsOptional()
  @Type(() => String)
  to?: string;
}

export class NumberRangeFilterDto {
  @IsOptional()
  @IsNumber()
  @Type(() => Number)
  min?: number;

  @IsOptional()
  @IsNumber()
  @Type(() => Number)
  max?: number;
}

export class TournamentFiltersDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  game?: string[];

  @IsOptional()
  @IsArray()
  @IsEnum(TournamentStatus, { each: true })
  status?: TournamentStatus[];

  @IsOptional()
  @ValidateNested()
  @Type(() => DateRangeFilterDto)
  startTime?: DateRangeFilterDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => NumberRangeFilterDto)
  buyIn?: NumberRangeFilterDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => NumberRangeFilterDto)
  guaranteedPrizePool?: NumberRangeFilterDto;
}

export class AdminGetTournamentsDto {
  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  sng?: boolean;

  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  includeArchived?: boolean;

  @IsOptional()
  @IsNumber()
  @Type(() => Number)
  skip?: number;

  @IsOptional()
  @IsNumber()
  @Type(() => Number)
  take?: number;

  @IsOptional()
  @IsEnum(TournamentSortBy)
  sortBy?: TournamentSortBy;

  @IsOptional()
  @IsEnum(Prisma.SortOrder)
  sortOrder?: Prisma.SortOrder;

  @IsOptional()
  @ValidateNested()
  @Type(() => TournamentFiltersDto)
  @IsObject()
  filters?: TournamentFiltersDto;
}

export interface GetTournamentsInfoResp {
  data: TournamentWComputed[];
  total: number;
  skip: number;
  take: number;
}

export interface AdminUnregisterPlayerDto {
  userId: string;
}
